import {ReactComponent as Question} from '../../../Assets/Icons/questionMark.svg';

import {ReactComponent as Operational} from '../../../Assets/Icons/operational.svg';
import {ReactComponent as Performance} from '../../../Assets/Icons/performance.svg';
import {ReactComponent as Partial} from '../../../Assets/Icons/partial.svg';
import {ReactComponent as Major} from '../../../Assets/Icons/major.svg';
import {ReactComponent as Maintenance} from '../../../Assets/Icons/maintenance.svg';

export const historyList = [
   {
      icon:<Performance />,
      fade:"fade-right",
      delay:100,
      date:"Jul 15 , 2021",
      title:"Some users are unable to download assets from prototypes",
      sub:"Products affected: Inspect",
      desc:"We've resolved the issue that prevented assets from downloading. We are so sorry for the interruption this may have caused. If you're still encountering any ongoing issues, please reach out to our support team: support@hostdesign.com."
   },
   {
      icon:<Partial />,
      fade:"fade-left",
      delay:100,
      date:"Jul 15 , 2021",
      title:"Some users are not able to access their invoices",
      sub:"Products affected: Authentication and user management, Authentication and user management",
      desc:"Our engineers have released a fix for the issue and invoices can be accessed again."
   },
   {
      icon:<Performance />,
      fade:"fade-right",
      delay:200,
      date:"Jul 15 , 2021",
      title:"We're investigating an issue that is causing a white bar to appear ",
      sub:"Products affected: Flat Prototypes",
      desc:"We've resolved the issue causing a white bar to appear above some prototypes in V7. We are so sorry for the interruption this may have caused. If you're still encountering any ongoing issues, please reach out to our support team: support@hostdesign.com."
   },
   {
      icon:<Partial />,
      fade:"fade-left",
      delay:200,
      date:"Jul 15 , 2021",
      title:"“Oops, something went wrong. Please try again” error New DSM",
      sub:"Products affected: DSM web view",
      desc:"The issue has now been resolved. Content can now be added to DSM again as expected. Our apologies for the disruption."
   },
   {
      icon:<Performance />,
      fade:"fade-right",
      delay:300,
      date:"Jul 15 , 2021",
      title:"Some users are unable to download assets from prototypes",
      sub:"Products affected: Inspect",
      desc:"We've resolved the issue that prevented assets from downloading. We are so sorry for the interruption this may have caused. If you're still encountering any ongoing issues, please reach out to our support team: support@hostdesign.com."
   },
   {
      icon:<Partial />,
      fade:"fade-left",
      delay:300,
      date:"Jul 15 , 2021",
      title:"Some users are not able to access their invoices",
      sub:"Products affected: Authentication and user management, Authentication and user management",
      desc:"Our engineers have released a fix for the issue and invoices can be accessed again."
   },
]

export const keyList = [
   {
      icon:<Operational />,
      title:"Operational"
   },
   {
      icon:<Performance />,
      title:"Degraded performance"
   },
   {
      icon:<Partial />,
      title:"Partial disruption"
   },
   {
      icon:<Major />,
      title:"Major disruption"
   },
   {
      icon:<Maintenance />,
      title:"Maintenance"
   }
]
export const tablesData = [
    {
       icon:<Question />,
       title:"Prototypes"
    },
    {
        icon:<Question />,
        title:"Project Editor"
     },
     {
        icon:<Question />,
        title:"Design Sync"
     },
     {
        icon:<Question />,
        title:"GraphQL Platform API"
     },
]
export const tablesData2 = [
    {
       icon:<Question />,
       title:"Design Tool"
    },
    {
        title:"Sketch plugin"
     },
     {

        title:"Billing"
     },
     {
        title:"Blog"
     },
]